declare namespace $ {

	type $mol_textarea__value_shm_hitalama_benchmarks_page_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['computer'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__hint_shm_hitalama_benchmarks_page_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__length_max_shm_hitalama_benchmarks_page_3 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_textarea['length_max'] >
	>
	type $mol_labeler__title_shm_hitalama_benchmarks_page_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_benchmarks_page_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_select__value_shm_hitalama_benchmarks_page_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['count'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_benchmarks_page_7 = $mol_type_enforce<
		({ 
			'1': string,
			'10': string,
			'100': string,
			'500': string,
			'1000': string,
			'2000': string,
			'4000': string,
			'8000': string,
			'all': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_shm_hitalama_benchmarks_page_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_benchmarks_page_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_select__value_shm_hitalama_benchmarks_page_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['fields'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_benchmarks_page_11 = $mol_type_enforce<
		({ 
			'4': string,
			'10': string,
			'all': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_shm_hitalama_benchmarks_page_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_benchmarks_page_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_shm_hitalama_benchmarks_page_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_benchmarks_page_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_select__value_shm_hitalama_benchmarks_page_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['packing'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_benchmarks_page_17 = $mol_type_enforce<
		({ 
			'granular': string,
			'packed': string,
			'all': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_shm_hitalama_benchmarks_page_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_benchmarks_page_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_button_major__title_shm_hitalama_benchmarks_page_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_hitalama_benchmarks_page_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['start_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_hitalama_benchmarks_page_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['start'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_benchmarks_page_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_hitalama_benchmarks_page_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['stop_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_hitalama_benchmarks_page_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['stop'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_text__text_shm_hitalama_benchmarks_page_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['status_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_hitalama_benchmarks_page_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['duration_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_hitalama_benchmarks_page_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['error_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $shm_hitalama_guide_page__title_shm_hitalama_benchmarks_page_29 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_guide_page['title'] >
	>
	type $shm_hitalama_guide_page__help_section_shm_hitalama_benchmarks_page_30 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_guide_page['help_section'] >
	>
	type $shm_hitalama_guide_page__minimal_width_shm_hitalama_benchmarks_page_31 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_hitalama_guide_page['minimal_width'] >
	>
	type $shm_hitalama_guide_page__body_shm_hitalama_benchmarks_page_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_guide_page['body'] >
	>
	type $shm_hitalama_benchmarks_client_frame__client_shm_hitalama_benchmarks_page_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['client'] >
		,
		ReturnType< $shm_hitalama_benchmarks_client_frame['client'] >
	>
	type $shm_hitalama_benchmarks_client_frame__title_shm_hitalama_benchmarks_page_34 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_benchmarks_client_frame['title'] >
	>
	type $shm_hitalama_benchmarks_client_frame__uri_shm_hitalama_benchmarks_page_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['frame_uri'] >
		,
		ReturnType< $shm_hitalama_benchmarks_client_frame['uri'] >
	>
	type $shm_hitalama_benchmarks_client_frame__minimal_height_shm_hitalama_benchmarks_page_36 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_hitalama_benchmarks_client_frame['minimal_height'] >
	>
	type $shm_paginator__page_shm_hitalama_benchmarks_page_37 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['page_number'] >
		,
		ReturnType< $shm_paginator['page'] >
	>
	type $shm_paginator__total_shm_hitalama_benchmarks_page_38 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['total_rows'] >
		,
		ReturnType< $shm_paginator['total'] >
	>
	type $shm_hitalama_benchmarks_page_metrics__records_shm_hitalama_benchmarks_page_39 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['metrics'] >
		,
		ReturnType< $shm_hitalama_benchmarks_page_metrics['records'] >
	>
	type $shm_hitalama_benchmarks_page_metrics__row_delete_shm_hitalama_benchmarks_page_40 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['row_delete'] >
		,
		ReturnType< $shm_hitalama_benchmarks_page_metrics['row_delete'] >
	>
	type $mol_button_download__title_shm_hitalama_benchmarks_page_41 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $mol_button_download__blob_shm_hitalama_benchmarks_page_42 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page['report_blob'] >
		,
		ReturnType< $mol_button_download['blob'] >
	>
	type $mol_button_download__file_name_shm_hitalama_benchmarks_page_43 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_page__title_shm_hitalama_benchmarks_page_44 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__minimal_width_shm_hitalama_benchmarks_page_45 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_page['minimal_width'] >
	>
	type $mol_page__body_shm_hitalama_benchmarks_page_46 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	export class $shm_hitalama_benchmarks_page extends $mol_book2 {
		connection_auto( ): any
		archive_auto( ): any
		indexes_auto( ): any
		computer( next?: string ): string
		Computer( ): $mol_textarea
		Computer_label( ): $mol_labeler
		count( next?: string ): string
		Count( ): $mol_select
		Count_label( ): $mol_labeler
		fields( next?: string ): string
		Fields( ): $mol_select
		Fields_label( ): $mol_labeler
		Storage_label( ): $mol_labeler
		packing( next?: string ): string
		Packing( ): $mol_select
		Packing_label( ): $mol_labeler
		start_enabled( ): boolean
		start( next?: any ): any
		Start( ): $mol_button_major
		stop_enabled( ): boolean
		stop( next?: any ): any
		Stop( ): $mol_button_minor
		status_text( ): string
		Status( ): $mol_text
		duration_text( ): string
		Duration( ): $mol_text
		error_text( ): string
		Error( ): $mol_text
		Settings( ): $shm_hitalama_guide_page
		client( ): $shm_hitalama_benchmarks_client
		frame_uri( ): string
		Live( ): $shm_hitalama_benchmarks_client_frame
		live_views( ): readonly(any)[]
		total_rows( ): number
		Pagination_top( ): $shm_paginator
		pagination_views( ): readonly(any)[]
		metrics( ): Record<string, any>
		row_delete( id: any, next?: any ): any
		Metrics( ): $shm_hitalama_benchmarks_page_metrics
		report_blob( ): $mol_blob
		Report_download( ): $mol_button_download
		Results( ): $mol_page
		menu_title( ): string
		version( ): string
		page_number( next?: number ): number
		auto( ): readonly(any)[]
		pages( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map